<div class="user-avatar">
    <avatar
        [small]="small"
        [userId]="user?.id"
        [name]="user?.name"
        [surname]="user?.surname"
        [nickname]="user?.nickname"
        [medium]="medium"
        [thumbnails]="{thumbnail_M: user?.avatarThumbnailMUrl || user?.avatarUrl, thumbnail_S: user?.avatarThumbnailSUrl || user?.avatarThumbnailMUrl }"
        [state]="user?.state"
        [access]="user?.lastAccessDate"
        [showPopover]="showPopover"
        [popoverPosition]="popoverPosition"
        [shortVersion]="shortVersion"
        [anonymous]="anonymous">
    </avatar>
    <div class="avatar-data truncate margin-left-8">
        @if (!hideName) {
            <span class="truncate" [textContent]="user?.name + ' ' + user?.surname" [class.avatar-data-name]="showUsername"></span>
        }
        @if (showUsername) {
            <span class="avatar-data-username truncate" [textContent]="user?.username"></span>
        }
    </div>
</div>
